import React, { useState, useEffect } from 'react';
import { Form, Input } from '@rocketseat/unform';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { toast } from 'react-toastify';
import { documentMaskPhone } from '~/util/documentInputMask';
import api from '~/services/api';
import apiBearer from '~/services/apiBearer';
import { Container, Loader } from './styles';
import apiWSCOM from '~/services/apiWSCOM';
import JotformEmbed from 'react-jotform-embed';

import { store } from '~/store';

export default function RepairRequest() {

  const token = useSelector(state => state.auth.token);
  apiBearer.defaults.headers.Authorization = `Bearer ${token}`;


  const property = useSelector(state => state.property.property);
  const [fullproperty, setFullproperty] = useState('');




  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [number, setNumber] = useState('');
  const [complement, setComplement] = useState('');
  const [district, setDistrict] = useState('');
  const [city, setCity] = useState('');
  const [estate, setEstate] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [service, setServiceRepair] = useState('');
  const [serviceOptions, setServiceOptions] = useState('');
  const [servicedescr, setServicedescr] = useState('');
  const [showFixForm, setShowFixForm] = useState(true);

  const [fullInquiline, setFullInquiline] = useState('');

  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );




  useEffect(() => {
    if (!property) return;

    
    apiBearer.get("/api/v1/WSListaImovel?referencia=" + property.reference).then(
      response => {
        setFullproperty(response.data.conteudo[0])
      },
      error => {
        toast.error('Erro interno, por favor tente novamente mais tarde.');
        console.error(error);
      }
    );

    apiBearer.get('/api/v1/WSFix', {
      params: {
        contrato: property.contract
          ? property.contract
          : property.businessId,
          }
    }).then(
      response => {
        setFullInquiline(response.data.conteudo)
      }
    );
    

    if (store.getState().user.profile) {
      const { conteudo } = store.getState().user.profile;

      console.log("User data: ", store.getState().user.profile)
      
      setName(store.getState().user.profile.nome);
      setEmail(store.getState().user.profile.email);
      setMobile(store.getState().user.profile.celular);

      let servicesList = [
          "Aquecedores",
          "Ar Condicionado",
          "Azulejo",
          "Chaves e Fechaduras",
          "Descupinização / Dedetização",
          "Devolução de Imóvel",
          "Elétrica",
          "Gás",
          "Gesso e DryWall",
          "Hidráulica",
          "Marcenaria",
          "Montagem de Móveis",
          "Papel de Parede",
          "Pequenas Reformas",
          "Persianas",
          "Pintura",
          "Piso Vinilico",
          "Reparos Pré-Locação",
          "Serralheria",
          "Serviços Gerais",
          "Telhado e Calha"
      ]

      setServiceOptions(servicesList.map((s)=>{
        return {
          value: s,
          label: s,
        }
      }))
    }

    // const jquery = document.createElement('script');
    // jquery.src =
    //   'https://ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js';
    // document.body.appendChild(jquery);

    // const widget = document.createElement('script');
    // widget.src = 'https://live.fix.com.br/assets/widget/js/widget-functions.js';
    // document.body.appendChild(widget);

    // const form = document.createElement('script');
    // form.src =
    //   'https://live.fix.com.br/assets/widget/js/solicitacao-form-load.js';
    // document.body.appendChild(form);

    async function loadFix() {
      try {
        const response = await apiBearer.get('/api/v1/WSFix', {
          params: {
            contrato: property.contract
              ? property.contract
              : property.businessId,
              },
          /*params: {
            contrato: "0000"
          },*/
        });

      
        console.log("Caiu aqui:::: ", response.data.conteudo)

        if (response.data.conteudo === null) {
          setShowFixForm(false)
          //toast.error(response.data.mensagem);
          return;
        }

        const {
          endereco,
          numero,
          complemento: compl,
          bairro,
          cidade,
          uf,
          cep,
          codigo,
          inicioContrato: inicio_contrato,
          saldo: valor_aluguel,
          nomeProprietario: nome,
          emailProprietario: email,
          cpfProprietario: cpf,
          celularProprietario: telefone,
          tokenFix,
          nomeInquilino,
          emailInquilino,
          celularInquilino,
          cpfInquilino,
        } = response.data.conteudo;

        const s = document.createElement('script');
        s.type = 'text/javascript';
        const code = `window.onload = function() {
          fix.config.css = { inputClass: "form-control", selectClass: "form-control", textareaClass: "form-control txtArea", buttonClass: "btn btn-primary", alertClass: "alert alert-danger" };
          fix.config.partnerId = "${tokenFix}";

          fix.solicitacao.usuario =
          {
            nome: "${nomeInquilino}",
            email: "${emailInquilino}",
            celular: "${celularInquilino}",
            cpf: "${cpfInquilino}"
          };

          fix.solicitacao.endereco =
          {
            endereco: "${endereco}",
            numero: "${numero}",
            compl: "${compl}",
            bairro: "${bairro}",
            cidade: "${cidade}",
            uf: "${uf}",
            cep: "${cep}",
            codigo: "${codigo}",
            inicio_contrato: "${inicio_contrato}",
            valor_aluguel: ${valor_aluguel}
          };

          fix.solicitacao.aprovador =
          {
            nome: "${nome}",
            email: "${email}",
            cpf: "${cpf}",
            telefone: "${telefone}"
          };

          fix.init();
          }`;

        if (showFixForm) {
          try {
            s.appendChild(document.createTextNode(code));
            document.body.appendChild(s);
          } catch (e) {
            s.text = code;
            document.body.appendChild(s);
          }
        }

      } catch (error) {
        /*toast.error(
          'Ocorreu um erro interno, por favor tente novamente mais tarde.'
        );*/
        console.error(error);
        setShowFixForm(false)
      }
    }

    //loadFix();

    window.setTimeout(() => dispatchEvent(new Event('load')), 1000);
  }, [property, property.contract, showFixForm]);

  async function handleSubmit(data) {
    

    let dataLabel = {
        'name': 'Nome Completo',
        'email': 'E-mail',
        'mobile': 'Celular',
        'address': 'Endereço',
        'number': 'Número',
        'complement': 'Complemento',
        'district': 'Bairro',
        'city': 'Cidade',
        'estate': 'UF',
        'zipcode': 'CEP',
        'service': 'Tipo do Serviço',
        'servicedescr': 'Descrição do Serviço'
    }


    setLoader(true);

    let mailContent = "<table style='width: 90%; border: 1px solid #000;'>"
    Object.keys(data).map((key)=>{
      if (typeof dataLabel[key] != "undefined") {
        mailContent += `<tr> <td><strong>` + dataLabel[key] + `:</strong></td> <td>` + data[key] + `</td></tr>`
      }
    })
    mailContent += "</table>"

    let franquiaEmail = fullproperty.emailFranquia

    let franquiasCustomMail = {
      'S.C. Aver E Cia Ltda Me':'edilaine.zandavalli@apolarpatobranco.com.br',
      'Perola do Atlantico Imoveis Ltda - Itapoa':'denise.garcia@apolaritapoa.com.br',
      'Mrm Assessoria Imobiliária Ltda Me':'denise.garcia@apolaritapoa.com.br',
      'More Bem Imobiliaria Ltda Me':'cassia.silva@apolarpontagrossa.com.br',
      'S.F.J. Assessoria Imobiliaria Eireli- Me':'apolar@apolarlondrina.com.br',
      'Bc Consultoria Imobiliária Ltda.':'apolar@apolarbalneariocamboriu.com.br',
      'Imobiliária Ro&Mi Ltda.':'apolar.norte@apolarjoinville.com.br'
    }

    if (typeof franquiasCustomMail[fullproperty.nomeFranquia] != "undefined" ) {
      franquiaEmail = franquiasCustomMail[fullproperty.nomeFranquia]
    }

    apiWSCOM
      .post('api/email', {
        Destinatario: franquiaEmail,
        Subject: 'Solicitação de Reparos',
        EmailBody: mailContent,
      })
      .then(
        response => {
          const { sucesso: success, mensagem: message } = response.data;
         
          if (success) {
            toast.success(
              'Sua Solicitação de Reparos foi enviada com sucesso! Nossa equipe irá analisá-la e entraremos em contato com você.'
            );
          } else {
            console.error(message);
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <div className="header">
        <h1>{property.topic || 'Solicitação de Reparos'}</h1>

        <div>
          <span>Ref.: {property.reference}</span>
          <span>
            Contrato:{' '}
            {property.contract ? property.contract : property.businessId}
          </span>
          <span>{property.address}</span>
        </div>
      </div>

      {/* <div style={{ display: showFixForm ? 'block' : 'none' }} id="fix-widget-container" /> */}

      

      { typeof fullInquiline.nomeInquilino != "undefined" && (
        <JotformEmbed 
        className="refera-form"
        style={{ display: showFixForm ? 'block' : 'none'}} 
        src={`https://form.jotformeu.com/221325154720647/?loc=${fullInquiline.nomeInquilino}&cpf=${fullInquiline.cpfInquilino}&email=${fullInquiline.emailInquilino}&fone=${fullInquiline.celularInquilino}&franquia=${fullInquiline.tokenFix}&rua=${fullInquiline.endereco}&numero=${fullInquiline.numero}&comple=${fullInquiline.complemento}&bairro=${fullInquiline.bairro}&cidade=${fullInquiline.cidade}&uf=${fullInquiline.uf}&cep=${fullInquiline.cep}&numeroContrato=${(property.contract ? property.contract : property.businessId)}&codigoImovel=${fullInquiline.codigo}&inicioContrato=${fullInquiline.inicioContrato}&saldo=${fullInquiline.saldo}&nomeProp=${fullInquiline.nomeProprietario}&celularProp=${fullInquiline.celularProprietario}&emailProp=${fullInquiline.emailProprietario}&cpfProp=${fullInquiline.cpfProprietario}&
        `}
      />
      )}


      <Form className="CustomFormRequestRepair" style={{ display: showFixForm ? 'none' : 'block' }} onSubmit={handleSubmit}>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <label>Nome</label>
            <Input
                maxLength="100"
                name="name"
                placeholder=""
                value={name}
                onChange={e => {
                  setName(e.target.value);
                }}
              />
          </Grid>
          

          <Grid item xs={8}>
            <label>E-mail</label>
            <Input
              maxLength="150"
              name="email"
              placeholder=""
              value={email}
              onChange={e => {
                setEmail(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={4}>
            <label>Celular</label>
            <Input
              maxLength="20"
              name="mobile"
              placeholder=""
              value={mobile}
              onChange={e => {
                setMobile(documentMaskPhone(e.target.value));
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <label>Endereço</label>
            <Input
              maxLength="100"
              name="address"
              placeholder=""
              value={address}
              onChange={e => {
                setAddress(e.target.value);
              }}
            />
          </Grid>


          <Grid item xs={2}>
            <label>Número</label>
            <Input
              maxLength="8"
              name="number"
              placeholder=""
              value={number}
              onChange={e => {
                setNumber(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={5}>
            <label>Complemento</label>
            <Input
              maxLength="50"
              name="complement"
              placeholder=""
              value={complement}
              onChange={e => {
                setComplement(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={5}>
            <label>Bairro</label>
            <Input
              maxLength="50"
              name="district"
              placeholder=""
              value={district}
              onChange={e => {
                setDistrict(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <label>Cidade</label>
            <Input
              maxLength="50"
              name="city"
              placeholder=""
              value={city}
              onChange={e => {
                setCity(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={2}>
            <label>UF</label>
            <Input
              maxLength="2"
              name="estate"
              placeholder=""
              value={estate}
              onChange={e => {
                setEstate(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={4}>
            <label>CEP</label>
            <Input
              maxLength="15"
              name="zipcode"
              placeholder=""
              value={zipcode}
              onChange={e => {
                setZipcode(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <label>Tipo do Serviço</label>
            <Select
              placeholder="Selecione o serviço"
              noOptionsMessage={() => 'Nenhum ano encontrado'}
              options={serviceOptions}
              onChange={e => {
                console.log(e)
                setServiceRepair(e.value);
              }}
            />
            <Input
              type="hidden"
              name="service"
              placeholder=""
              value={service}
            />
          </Grid>

          <Grid item xs={12}>
            <label>Descrição do Serviço</label>
            <Input
              multiline
              maxLength="500"
              name="servicedescr"
              placeholder=""
              value={servicedescr}
              onChange={e => {
                setServicedescr(e.target.value);
              }}
            />
          </Grid>

        </Grid>

        <button type="submit">Enviar Solicitação</button>
      </Form>
    </Container>
  );
}
